export class  Zoom {
    displayClass: string;
    imageData: any;
    slideIndex: number;
}
